// Check Reimbursement Balance
export const CHECK_REIMBURSEMENT_BALANCE_REQUEST = 'CHECK_REIMBURSEMENT_BALANCE_REQUEST';
export const CHECK_REIMBURSEMENT_BALANCE_DONE = 'CHECK_REIMBURSEMENT_BALANCE_DONE';
export const CHECK_REIMBURSEMENT_BALANCE_FAILED = 'CHECK_REIMBURSEMENT_BALANCE_FAILED';
export const CHECK_REIMBURSEMENT_BALANCE_RESET = 'CHECK_REIMBURSEMENT_BALANCE_RESET';